export const ENUM__redux_slice = {
  APP_INFO: 'slice_app_info',
  COLLECTION: 'slice_collections',
  GENERATION: 'slice_generation',
  GENERATION_PRICE: 'slice_generation_price',
  GRID2D: 'slice_grid2d',
  IMAGES: 'slice_images',
  ML_ASSET: 'slice_ml_asset',
  NETWORK: 'slice_network',
  SEARCH: 'slice_search',
  USER: 'slice_user',
  UI: 'slice_ui',
  VISION: 'SLICE__vision',
  WORDS: 'slice_words',
  WORKSPACE: 'slice_workspace',
  WORKSPACE_BILLING: 'slice_workspace_billing',

  /*
   * ADMIN
   */
  ADMIN_USERS: 'slice_admin_users',

  /*
   * SYSTEM
   */
  PERSIST: 'persist',
  _PERSIST: '_persist',
  GLOBAL: 'global',
};
